import React from 'react';

const EstadosDrodpdown = ({className, items, selectedValue, changeFn}) => {

  return(
  <div className={className}>
    <select className="form-control EstadosDropdown"
      onChange={(e) => changeFn(e.target.value)}
    >
      <option key={0}>Todos</option>
      {items.map(item =>
        item.nombre === selectedValue ?
        <option key={item.Id} selected>{item.Descripcion}</option> : <option key={item.Id}>{item.Descripcion}</option>
      )}
    </select>
  </div>
  );

}

export default EstadosDrodpdown;
